import React from 'react'

import List from '../../crud/list'
import {
  formatGroup,
  formatMembers,
  formatSentDate,
  formatStatus
} from './formatters'
import menuItems from './menuItems'

const columns = [
  { title: 'Date Sent', prop: 'date_sent', format: formatSentDate, sortable: false },
  { title: 'Reminder Name', prop: 'name', sortable: false },
  { title: 'Session', prop: 'session.name', sortable: false },
  { title: 'Group', prop: 'group.name', format: formatGroup, sortable: false },
  { title: 'Members', prop: '', format: formatMembers, sortable: false },
  { title: 'Status', prop: 'status', format: formatStatus, sortable: false }
]

const defaults = {
  order: [{ column: 'updated_at', direction: 'desc' }]
}

const CommentBotRuns = (props) => (
  <List
    title='Comment Bot Runs'
    apiPath='admin/comment_bot_runs'
    columns={columns}
    defaults={defaults}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    buildMenuItems={menuItems}
    hideCreate
  />
)

export default CommentBotRuns
